import { Colors, Fonts } from '../../theme';
import { textStyles } from '../../theme/fonts-ppv';
import styleText from '../rbh-text/styles';

export default {
  inputDefault: {
    width: 300,
    height: 40,
    borderRadius: 4,
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
  },
  inputDefaultMap: {
    width: 300,
    height: 40,
    borderRadius: 4,
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
  },
  inputWidth180: {
    width: 180,
    height: 40,
     ...textStyles.body2,
    fontSize: Fonts.size.text14,
  },
  inputWidth150: {
    width: 150,
    height: 40,
    ...textStyles.body2,
    fontSize: Fonts.size.text14,
  },
  inputWidth142: {
    width: 142,
    height: 40,
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
  },
  inputWidth276: {
    width: 276,
    height: 40,
    ...styleText.textRegular14,
    color: Colors.font.primary.fakeBlack
  },
  inputTableSearch: {
    width: 200,
    height: 40,
    boxShadow: 'none',
    borderColor: '#D9D9D9',
    fontFamily: 'Kanit-Regular'
  },
  inputArea: {
    width: 300,
    height: 88
  },
  outlinedPlaceholder: {
    position: 'absolute',
    left: '12px',
    top: '11px',
    pointerEvents: 'none',
    transition: '0.2s ease all',
    color: '#6D709B',
  },
  outlinedLabel: {
    top: '-11px',
    padding: '0 4px',
    marginLeft: '-4px',
    color: '#9597BD',
  },
  outlinedGradientLinear: {
    background: 'linear-gradient(to bottom, white 50%, #f5f5f5 50%)'
  },
  outlinedWhiteBg: {
    background: 'white'
  }
};
